import {
  Tooltip,
  Bar,
  CartesianGrid,
  ComposedChart,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { useTheme } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

import { SurveyData } from './types';
import { BAR_SIZE, labelBySurveyMetricField } from './constants';
import { renderTooltip } from './renderTooltip';

export type SurveyChartProps = {
  items: SurveyData[];
};

export const SurveyChart = ({ items }: SurveyChartProps) => {
  const { palette } = useTheme();

  return (
    <ResponsiveContainer width='100%' height={220}>
      <ComposedChart data={items}>
        <CartesianGrid vertical={false} />

        <XAxis dataKey='date' tickLine={false} tick={{ fontSize: '1rem', fontWeight: 500 }} />

        {/* Uncomment when we have response rate data */}
        {/* <YAxis
          yAxisId='left'
          domain={[0, 100]}
          tickFormatter={(value) => `${value}%`}
          tick={{ fill: colors.line, fontSize: '1rem', fontWeight: 500 }}
          color={colors.line}
          tickLine={false}
          axisLine={false}
        /> */}

        <YAxis
          yAxisId='right'
          orientation='right'
          tick={{
            fill: palette.SurveyMetricsChart.surveyViewBarColor,
            fontSize: '1rem',
            fontWeight: 500,
          }}
          tickLine={false}
          axisLine={false}
          // Uncomment when we have response rate data so that the bar chart doesn't overlap with the line chart
          // domain={[0, (dataMax: number) => Math.ceil((dataMax * 2.2) / 100) * 100]}
        />

        <Tooltip content={renderTooltip} />

        <Legend
          verticalAlign='bottom'
          formatter={(value: keyof Omit<SurveyData, 'date'>) => {
            return (
              <Typography
                variant='body2'
                color='textSecondary'
                component='span'
                sx={{ fontSize: '1.2rem' }}
              >
                {labelBySurveyMetricField[value]}
              </Typography>
            );
          }}
          wrapperStyle={{
            color: 'grey',
          }}
        />

        {/* Uncomment when we have response rate data */}
        {/* <Line
          yAxisId='left'
          dataKey='responseRate'
          type='linear'
          stroke={colors.line}
          strokeWidth={2}
          dot={{ r: 3, fill: colors.line }}
        /> */}

        <Bar
          yAxisId='right'
          dataKey='surveyViews'
          fill={palette.SurveyMetricsChart.surveyViewBarColor}
          radius={[3, 3, 0, 0]}
          barSize={BAR_SIZE}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
